<template>
  <div class="bg p-3 pb-20 mb-auto h-full overflow-auto bg-gradient-to-b from-gray-800 to-black text-white">
    <div class="max-w-wull mx-auto">
      <!-- Header -->
      <div class="mb-4">
        <h1 class="text-xl font-semibold">สร้าง Outpost</h1>
        <p class="text-sm text-gray-300">กรอกข้อมูล แล้วกดบันทึกเพื่อสร้างเอกสารใน <span class="font-mono">outposts</span></p>
      </div>

      <!-- Card -->
      <div class="bg-gray-900 bg-opacity-60 border border-gray-700 rounded-2xl p-4 shadow-xl">
        <form @submit.prevent="save" class="grid grid-cols-1 md:grid-cols-5 gap-4">
          <!-- Left: form fields -->
          <div class="md:col-span-3 space-y-4">
            <!-- Name -->
            <div>
              <label class="block text-sm text-gray-300 mb-1">ชื่อด่าน (name) <span class="text-red-400">*</span></label>
              <input
                v-model.trim="form.name"
                type="text"
                placeholder="เช่น ด่านสุขุมวิทย์"
                class="w-full rounded-xl bg-gray-800 border border-gray-700 focus:border-emerald-500 px-3 py-2 outline-none"
                required
              />
              <p class="text-xs text-gray-400 mt-1">เอกสารจะถูกบันทึกที่ <span class="font-mono">outposts/{ชื่อด่าน}</span></p>
            </div>

            <!-- Location -->
            <div>
              <label class="block text-sm text-gray-300 mb-1">สถานที่ตั้ง (location) <span class="text-red-400">*</span></label>
              <select
                v-model="form.location"
                class="w-full rounded-xl bg-gray-800 border border-gray-700 focus:border-emerald-500 px-3 py-2 outline-none"
                required
              >
                <option value="">เลือกสถานที่</option>
                <option v-for="loc in locations" :key="loc" :value="loc">{{ loc }}</option>
              </select>
            </div>

            <!-- Owner -->
            <div>
              <label class="block text-sm text-gray-300 mb-1">เจ้าของ (owner)</label>
              <input
                v-model.trim="form.owner"
                type="text"
                placeholder="Player1"
                class="w-full rounded-xl bg-gray-800 border border-gray-700 focus:border-emerald-500 px-3 py-2 outline-none"
              />
            </div>

            <!-- Level -->
            <div>
              <label class="block text-sm text-gray-300 mb-1">เลเวล (level)</label>
              <input
                v-model.number="form.level"
                type="number"
                min="1"
                placeholder="1"
                class="w-full rounded-xl bg-gray-800 border border-gray-700 focus:border-emerald-500 px-3 py-2 outline-none"
              />
            </div>

            <!-- Occupation Fields (ใต้ Level) -->
            <div>
              <label class="block text-sm text-gray-300 mb-1">UID ผู้ยึดครองปัจจุบัน (occupierUid)</label>
              <input
                v-model.trim="form.occupierUid"
                type="text"
                placeholder="UID ของผู้เล่น (เว้นว่างหากไม่มี)"
                class="w-full rounded-xl bg-gray-800 border border-gray-700 focus:border-emerald-500 px-3 py-2 outline-none"
              />
            </div>

            <div>
              <label class="block text-sm text-gray-300 mb-1">คะแนนยึดครอง (occupationScore)</label>
              <input
                v-model.number="form.occupationScore"
                type="number"
                min="0"
                placeholder="0"
                class="w-full rounded-xl bg-gray-800 border border-gray-700 focus:border-emerald-500 px-3 py-2 outline-none"
              />
            </div>

            <div>
              <label class="block text-sm text-gray-300 mb-1">รางวัลรายวันสำหรับผู้ยึดครอง (เพชร) (dailyDiamondReward)</label>
              <input
                v-model.number="form.dailyDiamondReward"
                type="number"
                min="0"
                placeholder="0"
                class="w-full rounded-xl bg-gray-800 border border-gray-700 focus:border-emerald-500 px-3 py-2 outline-none"
              />
            </div>

            <!-- Description -->
            <div>
              <label class="block text-sm text-gray-300 mb-1">คำอธิบาย (description)</label>
              <textarea
                v-model.trim="form.description"
                rows="3"
                placeholder="คำอธิบายสั้นๆ เกี่ยวกับด่านนี้…"
                class="w-full rounded-xl bg-gray-800 border border-gray-700 focus:border-emerald-500 px-3 py-2 outline-none resize-y"
              ></textarea>
            </div>

            <!-- isActive -->
            <div>
              <label class="inline-flex items-center gap-2 w-full">
                <input type="checkbox" v-model="form.isActive" class="rounded bg-gray-800 border-gray-700" />
                <span class="text-sm text-gray-300">เปิดใช้งาน (isActive)</span>
              </label>
            </div>

            <!-- Loot Items -->
            <div>
              <label class="block text-sm text-gray-300 mb-1">สมบัติ (lootItems)</label>
              <p class="text-xs text-gray-400 mb-2">เพิ่มสิ่งของที่อาจดรอปได้ โอกาส 1-10000 (1000 = 10%)</p>
              <div v-for="(loot, idx) in form.lootItems" :key="idx" class="flex items-center gap-2 mb-2 p-3 bg-gray-800 rounded-xl border border-gray-700">
                <input
                  v-model.trim="loot.item"
                  placeholder="ชื่อไอเทม"
                  class="flex-1 rounded-lg bg-gray-700 border border-gray-600 focus:border-emerald-500 px-3 py-1.5 outline-none text-sm"
                />
                <input
                  v-model.number="loot.chance"
                  type="number"
                  min="1"
                  max="10000"
                  placeholder="1000"
                  class="w-24 rounded-lg bg-gray-700 border border-gray-600 focus:border-emerald-500 px-3 py-1.5 outline-none text-sm"
                />
                <button
                  type="button"
                  @click="removeLoot(idx)"
                  class="px-3 py-1.5 bg-red-600 hover:bg-red-700 rounded-lg text-xs font-medium transition-colors"
                >
                  ลบ
                </button>
              </div>
              <button
                type="button"
                @click="addLoot"
                class="w-full px-4 py-2 bg-emerald-600 hover:bg-emerald-700 rounded-xl text-sm font-medium transition-colors"
              >
                + เพิ่มสมบัติ
              </button>
            </div>

            <!-- Defenders -->
            <div>
              <label class="block text-sm text-gray-300 mb-1">NPC ชาวบ้านที่ปกป้อง (defenders)</label>
              <p class="text-xs text-gray-400 mb-2">สูงสุด 5 ชื่อ</p>
              <div v-for="(npc, idx) in form.defenders" :key="idx" class="flex items-center gap-2 mb-2 p-3 bg-gray-800 rounded-xl border border-gray-700">
                <input
                  v-model.trim="form.defenders[idx]"
                  placeholder="ชื่อ NPC"
                  class="flex-1 rounded-lg bg-gray-700 border border-gray-600 focus:border-emerald-500 px-3 py-1.5 outline-none text-sm"
                />
                <button
                  type="button"
                  @click="removeDefender(idx)"
                  class="px-3 py-1.5 bg-red-600 hover:bg-red-700 rounded-lg text-xs font-medium transition-colors"
                >
                  ลบ
                </button>
              </div>
              <button
                type="button"
                @click="addDefender"
                :disabled="form.defenders.length >= 5"
                class="w-full px-4 py-2 bg-emerald-600 hover:bg-emerald-700 disabled:opacity-50 disabled:cursor-not-allowed rounded-xl text-sm font-medium transition-colors"
              >
                + เพิ่ม NPC
              </button>
            </div>

            <!-- canCapture -->
            <div>
              <label class="inline-flex items-center gap-2 w-full">
                <input type="checkbox" v-model="form.canCapture" class="rounded bg-gray-800 border-gray-700" />
                <span class="text-sm text-gray-300">สามารถยึดได้ (canCapture)</span>
              </label>
            </div>
          </div>

          <!-- Right: image & preview -->
          <div class="md:col-span-2 space-y-4">
            <div>
              <label class="block text-sm text-gray-300 mb-1">ลิงก์รูป Outpost (imageUrl)</label>
              <input
                v-model.trim="form.imageUrl"
                type="url"
                placeholder="https://example.com/my-outpost.png"
                class="w-full rounded-xl bg-gray-800 border border-gray-700 focus:border-emerald-500 px-3 py-2 outline-none"
              />
              <p class="text-xs text-gray-400 mt-1">วางลิงก์ภาพได้เลย ไม่ต้องอัปโหลด</p>
            </div>

            <div class="rounded-2xl overflow-hidden border border-gray-700 bg-gray-800 aspect-video flex items-center justify-center">
              <img
                v-if="form.imageUrl"
                :src="form.imageUrl"
                alt="Preview"
                class="w-full h-full object-cover"
                @error="onImgError"
              />
              <div v-else class="text-gray-400 text-sm">ตัวอย่างรูปจะแสดงที่นี่</div>
            </div>
          </div>

          <!-- Actions -->
          <div class="md:col-span-5 flex items-center gap-3 pt-2">
            <button
              type="submit"
              :disabled="loading"
              class="px-4 py-2 rounded-xl bg-blue-600 disabled:opacity-60 disabled:cursor-not-allowed transition"
            >
              {{ loading ? 'กำลังบันทึก...' : 'บันทึก Outpost' }}
            </button>
            <span v-if="message" :class="messageType === 'error' ? 'text-red-400' : 'text-emerald-400'">{{ message }}</span>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue'
import { projectFirestore } from '@/firebase/config' // v8.10

export default {
  name: 'OutpostCreate',
  setup () {
    const form = ref({
      name: '',
      owner: '',
      level: 1,
      occupierUid: '',
      occupationScore: 0,
      dailyDiamondReward: 0,
      description: '',
      imageUrl: 'https://firebasestorage.googleapis.com/v0/b/zombiekub.firebasestorage.app/o/outpost%2Foutpostimg.png?alt=media&token=19b3d24c-1885-4101-84ec-a5b291ee2254',
      isActive: true,
      location: '',
      lootItems: [],
      defenders: [],
      canCapture: true
    })

    const locations = [
      'รถไฟฟ้าใต้ดิน',
      'โรงพยาบาล', 'สยามสแควร์', 'หมู่บ้านคนรวย', 'สวนสนุก', 'โรงงานอุตสาหกรรม', 'ห้างสรรพสินค้า',
      'สถานีดับเพลิงร้าง', 'ค่ายทหาร',
      'สถาบันวิจัยหุ่นยนต์', 'สถาบันวิจัยไวรัส', 'สุสานนักรบโบราณ', 'ตึกความมันคงแห่งชาติ',
      'โรงเก็บศพจักรกล', 'ตึกปฏิบัติการพันธุกรรม','กรุงเทพ'
    ]

    const loading = ref(false)
    const message = ref('')
    const messageType = ref('success')

    const addLoot = () => {
      form.value.lootItems.push({ item: '', chance: 1000 })
    }

    const removeLoot = (index) => {
      form.value.lootItems.splice(index, 1)
    }

    const addDefender = () => {
      if (form.value.defenders.length < 5) {
        form.value.defenders.push('')
      }
    }

    const removeDefender = (index) => {
      form.value.defenders.splice(index, 1)
    }

    const onImgError = () => {
      message.value = 'ไม่สามารถโหลดรูปจากลิงก์ได้ ตรวจสอบ URL อีกครั้ง'
      messageType.value = 'error'
    }

    const resetForm = () => {
      form.value = {
        name: '',
        owner: '',
        level: 1,
        occupierUid: '',
        occupationScore: 0,
        dailyDiamondReward: 0,
        description: '',
        imageUrl: 'https://firebasestorage.googleapis.com/v0/b/zombiekub.firebasestorage.app/o/outpost%2Foutpostimg.png?alt=media&token=19b3d24c-1885-4101-84ec-a5b291ee2254',
        isActive: true,
        location: '',
        lootItems: [],
        defenders: [],
        canCapture: true
      }
    }

    const save = async () => {
      message.value = ''
      messageType.value = 'success'

      const docId = form.value.name.trim()

      // ตรวจสอบขั้นต่ำ
      if (!docId || !form.value.location?.trim()) {
        message.value = 'กรุณากรอก ชื่อด่าน และสถานที่ตั้ง ให้ครบ'
        messageType.value = 'error'
        return
      }

      // Clean lootItems
      const cleanedLootItems = form.value.lootItems
        .map(l => ({
          item: l.item?.trim() || '',
          chance: Number(l.chance) || 0
        }))
        .filter(l => l.item && l.chance >= 1 && l.chance <= 10000)

      // Clean defenders
      const cleanedDefenders = form.value.defenders
        .map(d => d?.trim() || '')
        .filter(d => d)

      const payload = {
        name: docId,
        ownerUid: form.value.owner?.trim() || '',
        level: Number(form.value.level) || 1,
        occupierUid: form.value.occupierUid?.trim() || null,
        occupationScore: Number(form.value.occupationScore) || 0,
        dailyDiamondReward: Number(form.value.dailyDiamondReward) || 0,
        description: form.value.description?.trim() || '',
        imageUrl: form.value.imageUrl?.trim() || 'https://firebasestorage.googleapis.com/v0/b/zombiekub.firebasestorage.app/o/outpost%2Foutpostimg.png?alt=media&token=19b3d24c-1885-4101-84ec-a5b291ee2254',
        isActive: !!form.value.isActive,
        location: form.value.location.trim(),
        lootItems: cleanedLootItems,
        defenders: cleanedDefenders,
        canCapture: !!form.value.canCapture,
        createdAt: new Date(),
        updatedAt: new Date(),
        treasureOpened: false,
        treasureAvailableAt: null
      }

      try {
        loading.value = true
        await projectFirestore
          .collection('outposts')
          .doc(docId)
          .set(payload)

        // สร้าง outpostPrivate เพิ่มเติม
        const privatePayload = {
          ownerUid: form.value.owner?.trim() || ''
        }
        await projectFirestore
          .collection('outpostPrivate')
          .doc(docId)
          .set(privatePayload)

        message.value = `บันทึกสำเร็จ: outposts/${docId} และ outpostPrivate/${docId}`
        messageType.value = 'success'
        resetForm() // ล้างฟอร์มหลังบันทึกสำเร็จ
      } catch (e) {
        console.error(e)
        message.value = 'บันทึกล้มเหลว โปรดลองอีกครั้ง'
        messageType.value = 'error'
      } finally {
        loading.value = false
      }
    }

    return {
      form,
      locations,
      loading,
      message,
      messageType,
      addLoot,
      removeLoot,
      addDefender,
      removeDefender,
      save,
      onImgError
    }
  }
}
</script>

<style scoped>
.bg {
  background: url('https://firebasestorage.googleapis.com/v0/b/zombiekub.firebasestorage.app/o/bg%2Fmanagerroom.png?alt=media&token=6b9348b6-9364-4ce5-bf58-6e7b9c5b12f1') no-repeat center center fixed,
              linear-gradient(to bottom, rgba(31, 41, 55, 0.8), rgba(0, 0, 0, 0.9));
  background-size: cover;
}
</style>